import { useMutation, useQuery } from "react-query";
import * as registryPatientService from 'services/registryPatientService';
import { RegistryPatientDto } from "types/dto/RegistryPatientDto";

const getRegistryPatientById = async (dto: RegistryPatientDto) => {
  const procedure = await registryPatientService.getRegistryPatientById(dto);
  const images = await registryPatientService.getRegistryPatientImages(dto);

  const newImages = (images ?? []).map((item: any) => ({
    id: item.id,
    uri: item.urls.href_original,
    image_name: item.image_name,
    procedure: item.procedure,
  }));

  if (newImages) {
    procedure.data.data.images = newImages || [];
  }

  return procedure;
}

const updateRegistryPatientImages = async ({
  dto,
  images,
}: {
  dto: RegistryPatientDto,
  images: { uri: string; image_name: string }[];
}) => {
  const formData = new FormData();

  for (const image of images) {
    const response = await fetch(image.uri);
    const blob = await response.blob();

    const file = new File([blob], image.image_name, {
      type: blob.type || 'image/jpeg',
    });

    formData.append('images', file);
  }

  return registryPatientService.updateRegistryPatientImages(dto, formData);
};

const updateRegistryPatientImage = async ({
  dto,
  image
}: {
  dto: RegistryPatientDto,
  image: any
}) => {
  return await registryPatientService.updateRegistryPatientImage(dto, image);
}

const deleteRegistryPatientImage = async ({
  dto,
  imageId
}: {
  dto: RegistryPatientDto,
  imageId: number
}) => {
  return await registryPatientService.deleteRegistryPatientImage(dto, imageId);
}

const updateCaseImage = async ({
  dto,
  image
}: {
  dto: RegistryPatientDto,
  image: any
}) => {
  return await registryPatientService.updateRegistryPatientImage(dto, image);
}


// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************


export const useCreateRegistryPatient = (onSuccess: any, onError: any) => {
  return useMutation(registryPatientService.createRegistryPatient, {
    onSuccess,
    onError
  });
}

export const useUpdateRegistryPatient = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryPatientService.updateRegistryPatient, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useDeleteRegistryPatients = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(registryPatientService.deleteRegistryPatients, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useGetRegistryPatientById = (dto: RegistryPatientDto, options = {}) => {
  return useQuery({
    queryKey: ['registryPatient', dto],
    queryFn: () => getRegistryPatientById(dto),
    keepPreviousData: false,
    ...options,
  });
}



export const useUpdateRegistryPatientImages = (onSuccess: any, onError: any) => {
  return useMutation(updateRegistryPatientImages, {
    onSuccess,
    onError
  });
}

export const useUpdateRegistryPatientImage = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(updateRegistryPatientImage, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useDeleteRegistryPatientImage = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(deleteRegistryPatientImage, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useUpdateProcedureImage = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(updateCaseImage, {
    onSuccess,
    onError,
    ...options,
  });
}